import { Link } from '@tanstack/react-router';
import { useCallback, useEffect, useState } from 'react';

import ChevroneRightIcon from '@common/assets/icons/chevrone_right.svg?react';
import { useTabbar } from '@common/providers/useTabbar';
import { Card } from '@common/ui/Card';
import { Cell } from '@common/ui/Cell';
import { Separator } from '@common/ui/Separator';

import { usePostDeleteAccount } from '@services/hooks/UsersService';

import { DeleteAccountDialog } from './components';

export const MainSettings: React.FC = () => {
  const tabbar = useTabbar();

  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const { trigger: triggerPostDeleteAccount } = usePostDeleteAccount();

  const handleDelete = useCallback(
    async (reason: string) => {
      try {
        await triggerPostDeleteAccount({ reason });

        localStorage.clear();
        setShowDeleteDialog(false);

        setTimeout(() => window.location.reload(), 0);
      } catch (e) {
        console.error(e);
      }
    },
    [triggerPostDeleteAccount],
  );

  useEffect(() => {
    if (showDeleteDialog) {
      tabbar.setBottomSheet(
        <DeleteAccountDialog
          onDelete={handleDelete}
          onCancel={() => setShowDeleteDialog(false)}
        />,
      );
    } else {
      tabbar.setBottomSheet(null);
    }
  }, [showDeleteDialog]);

  return (
    <Card testId="main-settings" style={{ padding: '0 16px', gap: 2 }}>
      <Link to="/premium" data-test-id="main-settings-premium-link">
        <Cell
          testId="main-settings-premium"
          title="Настройки подписки"
          suffixIcon={<ChevroneRightIcon />}
          separator={<Separator />}
        />
      </Link>
      <Link
        to="/profile/settings/notifications"
        data-test-id="main-settings-notifications-link"
      >
        <Cell
          testId="main-settings-notifications"
          title="Уведомления от бота"
          suffixIcon={<ChevroneRightIcon />}
          separator={<Separator />}
        />
      </Link>
      <Cell
        testId="main-settings-delete"
        title="Удалить аккаунт"
        style={{ color: 'red' }}
        onClick={() => setShowDeleteDialog(true)}
      />
    </Card>
  );
};
